import axios from "axios";
import { getDigits } from "./getDigits.util";

export const getAddressByCep = async (cep: string) => axios.get(`https://viacep.com.br/ws/${getDigits(cep)}/json/`);
